import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authContext } from '../components/Context/AuthContext';
import React from 'react';


const PrivateRoute = ({ children }) => {
  const { token } = useContext(authContext);
  const location = useLocation();

  if (!token) {
    // Si no hay token, lo mando al login y guardo desde dónde vino
    // (se guarda también la query y el hash para volver exactamente a la misma URL)
    return <Navigate to="/login" state={{ from: `${location.pathname}${location.search}${location.hash}` }} replace />;
  }

  return children;
};

export default PrivateRoute;
